import { Inject, Injectable } from "@angular/core";
import { APP_TYPE, AppType } from "../app.type";

@Injectable({
  providedIn: "root",
})
export class DatesFilterService implements DatesFilterService {
  showComponent = false;
  model = {
    dateMode: "specific",
    specificDate: null,
    fromDate: null,
    toDate: null,
  };

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  clear() {
    this.app.datesFilter.model = {
      dateMode: "specific",
      specificDate: null,
      fromDate: null,
      toDate: null,
    };
  }
}
